/* src/app/pages/ui-kit/components/bulk-actions-bar-view/bulk-actions-bar-view.component.scss */
.card {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.card .bulk-table-container {
  margin-bottom: 16px;
}
/*# sourceMappingURL=bulk-actions-bar-view.component.css.map */
